/**
 * @generated SignedSource<<99f019b8f16d58f36d481f57abf36fee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type PopupListPageActiveJobQuery$variables = {};
export type PopupListPageActiveJobQueryVariables = PopupListPageActiveJobQuery$variables;
export type PopupListPageActiveJobQuery$data = {
  readonly activePopupImportJob: {
    readonly slug: string;
    readonly status: PopupImportJobStatus;
    readonly totalCount: number;
    readonly succeededCount: number;
    readonly failedCount: number;
    readonly retryCsv: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type PopupListPageActiveJobQueryResponse = PopupListPageActiveJobQuery$data;
export type PopupListPageActiveJobQuery = {
  variables: PopupListPageActiveJobQueryVariables;
  response: PopupListPageActiveJobQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "succeededCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failedCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryCsv",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupListPageActiveJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "activePopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PopupListPageActiveJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "activePopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f982f28070d0e3469c130e13459263d2",
    "id": null,
    "metadata": {},
    "name": "PopupListPageActiveJobQuery",
    "operationKind": "query",
    "text": "query PopupListPageActiveJobQuery {\n  activePopupImportJob {\n    slug\n    status\n    totalCount\n    succeededCount\n    failedCount\n    retryCsv\n    errorMessage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe30d433b4178e86d7cd829bdb637a1e";

export default node;
